import React from "react";
import ReactDOM from "react-dom/client";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import "@/index.css";
import App from "@/App";
import { msalConfig } from "./authConfig";

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL and handle redirect response
msalInstance.initialize().then(async () => {
  // CRITICAL: Handle redirect promise FIRST before anything else
  // This processes the auth response when returning from Microsoft login
  try {
    const response = await msalInstance.handleRedirectPromise();
    if (response) {
      console.log("Redirect login successful:", response.account?.username);
      msalInstance.setActiveAccount(response.account);
    }
  } catch (error) {
    console.error("Error handling redirect:", error);
  }

  // Set the active account if there is one
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0 && !msalInstance.getActiveAccount()) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  // Add event callback for future login events
  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
      msalInstance.setActiveAccount(event.payload.account);
    }
  });

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>,
  );
});
